import React, { useState } from 'react';
import { Redirect } from 'react-router-dom'
import { Button, Spinner } from "react-bootstrap";
import { Card, CardContent, CardHeader, IconButton } from "@material-ui/core";
import { 
    useDispatch, 
    shallowEqual, 
    useSelector 
} from "react-redux";
import * as actionsEstado from '../../../Public/Inscripciones/_redux/DetalleInscripcion/DetalleInscripcionActions';
import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';
//MODAL PARA ELIMINAR COSAS
import ModalDelete from '../../../Comun/Modal/ModalDelete';
import * as _ from "lodash";

import { DESCARGAR_CONSTANCIA_URL } from "../_redux/config"

import moment from 'moment';

//ICONOS
import DeleteIcon from '@material-ui/icons/Delete';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//import { func } from 'prop-types';


//FECHAS
const hoy = moment();
//const continuar = moment(process.env.REACT_APP_FECHA_CONTINUAR);
//const cierre = moment(process.env.REACT_APP_FECHA_CIERRE);

const CardInscripcion = (props) => {
    //PARAMETROS
    const { 
        llamadosActivos, 
        item,
        limpiarContenido, 
        cargarAspiranteAsync, 
        descartarInscripcion
    } = props;
    
    //DISPATCH
    const dispatch = useDispatch();

    //ESTADOS
    const [verModal, setVerModal] = useState(false);

    //ESTADO EN REDUX
    const { error: estadoError, detalleInscripcionInformacion: estadoInformacion, listLoading } = useSelector(
        state => state.detalleInscripcion,
        shallowEqual
    );

    const llamadosFilter = _.filter(llamadosActivos, function(o){
        return o.nivelEnsenanza === item.nivelEnsenanza;
    });

    const llamado = llamadosFilter && _.head(llamadosFilter);
    const hastaMoment = llamado ? moment(llamado.hasta) : moment();
    //Flag: Si la inscripcion aun no tiene nivel habilito edicion si existen llamados activos
    const sinNivelModif = !item.nivelEnsenanza && llamadosActivos && llamadosActivos.length > 0;

    return (
        <Card>
            <CardHeader
                style={{ backgroundColor: '#4ba4a9', color: 'white', textAlign: 'center' }}
                title={<h4 className="my-0">{`${item.apellido}, ${item.nombre}`}</h4>}
            />
            <CardContent className="mb-0 pb-2">
                <div>
                    <p className="mb-1"><b>Inscripción Número:</b> {item.finalizada ? item.inscripcionNumero : 'NO FINALIZADA'}</p>
                    <p className="mb-1"><b>Nivel:</b> {item.nivelEnsenanza ?? 'Nivel de Enseñanza no asignado'}</p>
                    <p className="mb-1"><b>DNI:</b> {item.documentoNumero} </p>
                    {item.finalizada ?
                        <p className="mb-1"><b>Estado:</b> Completa</p>
                        :
                        <p className="my-3 text-center">
                            <span className="d-inline p-2 " style={{ color: 'white', backgroundColor: 'orange', borderRadius: 4 }}>
                                Pendiente 
                                <WarningIcon style={{ paddingBottom: 2 }} />
                            </span>
                            
                            {(!llamadosActivos || llamadosActivos.length == 0 ||
                            (llamado && hoy.diff(hastaMoment, 'days') <= 0))
                                &&
                                <span className="d-inline p-2 ml-3" style={{ color: 'white', backgroundColor: 'crimson', borderRadius: 4 }}>
                                    No Finalizada 
                                    <ErrorIcon style={{ paddingBottom: 2 }} />
                                </span>
                            }
                        </p>
                    }
                    <div className="row col-12">
                        {estadoError && <SnackBarCustom tipo="error" mensaje={estadoError} />}
                        {estadoInformacion && <Redirect to={`/estado/${item.inscripcionNumero}`} />}
                        {item.finalizada ?
                            listLoading ?
                                <Spinner animation="border" variant="success" />
                                :
                                <>
                                    <Button size="sm" className="mr-3 mt-3 mb-3" variant="success"
                                        onClick={() => {
                                            dispatch(actionsEstado.fetchDetalleInscripcionInformacion({ codigo: item.inscripcionNumero }));
                                        }}
                                    >
                                        Ver Estado
                                    </Button>

                                    <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Descargar constancia de inscripción</Tooltip>}>
                                        <IconButton onClick={() => window.open(`${DESCARGAR_CONSTANCIA_URL}?codigo=${item.inscripcionNumero}`)} >
                                            {/* <DeleteIcon fontSize="large" style={{color: "#F64E60"}} /> */}
                                            <CloudDownloadIcon fontSize="large" color="secondary" />
                                        </IconButton>
                                    </OverlayTrigger>

                                    {/* 
                                    <Button size="sm" className="mr-3" variant="secondary"
                                        onClick={() => {
                                            dispatch(actionsEstado.fetchDetalleInscripcionInformacion({ codigo: item.inscripcionNumero }));
                                        }}
                                    >
                                        <FileDownloadIcon style={{ paddingBottom: 2 }} />
                                    </Button>
                                */}
                                </>
                            :
                            (sinNivelModif || (llamado && hoy.diff(hastaMoment, 'days') <= 0)) 
                                &&
                                <Button size="sm" className="mr-3 mt-3 mb-3" variant="success"
                                    onClick={() => {
                                        limpiarContenido();
                                        cargarAspiranteAsync(item.inscripcionId);
                                    }}
                                >
                                    Continuar
                                </Button>
                        }
                        {(sinNivelModif || (llamado && hoy.diff(hastaMoment, 'days') <= 0))
                            && 
                            <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Eliminar esta inscripción</Tooltip>}>
                                <IconButton onClick={() => setVerModal(true)}>
                                    <DeleteIcon fontSize="large" style={{color: "#EE2D41"}} />
                                </IconButton>
                            </OverlayTrigger>
                        }
                        <ModalDelete
                            show={verModal}
                            close={() => setVerModal(false)}
                            title="Inscripción"
                            text={`¿Desea Eliminar la inscripción ${item.inscripcionNumero} permanentemente?`}
                            deleteFunction={() => descartarInscripcion(item.inscripcionId)}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export default CardInscripcion;